import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseMyLocation: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.25C12.4142 0.25 12.75 0.585786 12.75 1V3C12.75 3.0103 12.7498 3.02055 12.7494 3.03075C17.1222 3.3912 20.6088 6.87778 20.9692 11.2506C20.9794 11.2502 20.9897 11.25 21 11.25H23C23.4142 11.25 23.75 11.5858 23.75 12C23.75 12.4142 23.4142 12.75 23 12.75H21C20.9897 12.75 20.9794 12.7498 20.9692 12.7494C20.6088 17.1222 17.1222 20.6088 12.7494 20.9692C12.7498 20.9794 12.75 20.9897 12.75 21V23C12.75 23.4142 12.4142 23.75 12 23.75C11.5858 23.75 11.25 23.4142 11.25 23V21C11.25 20.9897 11.2502 20.9794 11.2506 20.9692C6.87778 20.6088 3.3912 17.1222 3.03075 12.7494C3.02055 12.7498 3.0103 12.75 3 12.75H1C0.585786 12.75 0.25 12.4142 0.25 12C0.25 11.5858 0.585786 11.25 1 11.25H3C3.0103 11.25 3.02055 11.2502 3.03075 11.2506C3.3912 6.87778 6.87777 3.3912 11.2506 3.03075C11.2502 3.02055 11.25 3.0103 11.25 3V1C11.25 0.585786 11.5858 0.25 12 0.25ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        fill={color}
      />
    </svg>
  );
};
